module.exports = __webpack_public_path__ + "static/img/Ben-Kennedy.cdd9589.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Ben-Kennedy.jpg
// module id = x28q
// module chunks = 0